<template>
  <div>
    <div v-if="!questionAnswered" class="px-4">
      <div class="mt-6 py-5 text-left">
        <!-- <p class="text-sm mb-2">Frage {{ question.prio }} von 6</p> -->
        <h1 class="text-lg font-extralight">
          {{ generatedQuestion }}
        </h1>
        <p v-if="question.sub_question" class="mt-3 text-sm font-extralight">
          {{ question.sub_question }}
        </p>

        <div class="border-t border-gray-400 mt-4"></div>
      </div>

      <!-- <div class="sm:mt-6 px-4 py-5 text-center">
        <h1 class="text-2xl sm:text-question-large font-extralight">
          {{ generatedQuestion }}
        </h1>
      </div> -->

      <form @submit.prevent="submit" novalidate class="mt-3 text-center">
        <div v-for="(answer, idx) in form.answers" :key="idx">
          <div class="ml-auto mr-auto max-w-4xl rounded-md shadow-sm">
            <textarea v-model="answer.text" :disabled="sending" rows="1"
              placeholder="Bitte pro Punkt ein eigenes Eingabefeld."
              class="shadow-sm focus:ring-markencode-blue focus:border-markencode-blue mt-1 block w-full text-sm border border-gray-300 rounded-md  placeholder:text-gray-400"></textarea>
          </div>



          <button @click.prevent="addMore" v-if="
            idx + 1 == form.answers.length &&
            question.parameters.options.max_answers > form.answers.length
          " :disabled="!answer.text.length"
            class="max-w-4xl w-full ml-auto mr-auto mt-4 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md"
            :class="!answer.text.length
                ? 'cursor-default text-gray-500 bg-gray-200'
                : 'focus:outline-none active:bg-gray-400 transition duration-150 ease-in-out cursor-pointer bg-brandpreneurship-dark-gray text-white'
              "
              >
            {{ translations.add_more_info }}
          </button>

          <div class="border-t border-gray-400 mt-5 mb-4"></div>
        </div>

        <submit-button :sending="sending" :validated="validated" class="max-w-4xl ml-auto mr-auto mt-8">{{
          translations.save }}</submit-button>
      </form>
    </div>



    <div v-if="questionAnswered && session.show_live_results" class="mt-6 px-8 py-5 text-left">

      <p class="text-sm mb-2">Und das sagt die Gruppe:</p>

      <p class="font-extralight text-lg">{{ generatedQuestion }}</p>

      <div class="border-t border-gray-400 mt-4"></div>

      <scrollable-container :session="session" :translations="translations"></scrollable-container>
    </div>

    <div v-if="questionAnswered && !session.show_live_results" class="mt-6 px-8 py-5 text-left">
      <h1 class="text-3xl sm:text-4xl font-extralight mb-3">
        {{ translations.thank_you }}
      </h1>
    </div>

  </div>
</template>

<script>
import SubmitButton from '@/Shared/SubmitButton';
import HorizontalDivider from '@/Shared/HorizontalDivider';
import ScrollableContainer from '@/Pages/LiveResults/ScrollableContainer';
import { throttle } from 'lodash';

export default {
  components: {
    SubmitButton,
    HorizontalDivider,
    ScrollableContainer,
  },

  props: {
    translations: {},
    participant: {
      required: true,
    },
    question: {
      required: true,
    },
    session: {
      required: true,
      type: Object,
    },
    answerParameters: {},
  },

  data() {
    return {
      sending: false,
      answered: false,
      form: {
        answers: [{ text: '' }],
      },
    };
  },

  methods: {
    addMore() {
      this.form.answers.push({ text: '' });
    },
    submit() {
      this.sending = true;

      window.axios
        .post(
          this.route('live.questions.store', {
            uuid: this.participant.uuid,
            questionId: this.question.id,
          }),
          this.form
        )
        .then(() => {
          this.sending = false;
          this.answered = true;
        })
        .catch((error) => {
          this.sending = false;
        });
    },
  },

  computed: {
    generatedQuestion() {

      if (!this.question?.brandname && !this.session.brandname && this.question?.question_default) {
        return this.question?.question_default;
      }

      if (this.question?.is_placeholder_question && (this.question?.brandname || this.session.brandname)) {
        return this.question.question.replace('%BRANDNAME', this.question?.brandname || this.session.brandname);
      }

      return this.question.question;
    },

    validated() {
      return this.form.answers[0].text.length > 0;
    },
    questionAnswered() {
      return this.answerParameters || this.answered;
    },
    channel() {
      return Echo.channel(
        'markencode-app.session.' + this.participant.markencode_session.id
      );
    },
  },

  created() {
    // this.channel.here(users => {
    //   console.log(users);
    // });
  },

  destroyed() {
    console.log('leaving textblock multiple component');
    // this.channel.leave('markencode-live.session.' + this.participant.markencode_session.id);
  },

  // watch: {
  //   form: {
  //     handler: throttle(function() {
  //       this.channel.whisper('participant.busy', {
  //         participant_id: this.participant.id
  //       });
  //     }, 2000),
  //     deep: true
  //   }
  // }
};
</script>